export default "__VITE_ASSET__wkTLt4sW__"